import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { Picture } from "../lib/photos";

export function AmenityCard({ amenity, photo, className = "" }) {
  const Icon = Icons[amenity.icon] || Icons.Sparkles;
  return (
    <article
      className={`group relative bg-cream border border-tan overflow-hidden flex flex-col ${className}`}
      data-testid={`amenity-card-${amenity.slug}`}
    >
      <Link
        to={`/amenities/${amenity.slug}`}
        className="block aspect-[16/10] overflow-hidden bg-forest-800"
      >
        {photo && (
          <Picture
            photo={photo}
            className="block w-full h-full"
            imgClassName="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)]"
            sizes="(min-width: 1024px) 32vw, (min-width: 640px) 45vw, 100vw"
          />
        )}
      </Link>
      <div className="p-6 md:p-7 flex flex-col grow">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-9 h-9 grid place-items-center rounded-full bg-brass/15 text-brass">
            <Icon size={18} strokeWidth={1.75} />
          </span>
          <h3 className="font-display text-xl md:text-2xl text-forest-900 tracking-tight">
            <Link to={`/amenities/${amenity.slug}`} className="hover:text-brass">
              {amenity.label}
            </Link>
          </h3>
        </div>
        <p className="text-ink/80 text-[0.95rem] leading-relaxed mb-5 grow">{amenity.tagline}</p>
        <Link
          to={`/amenities/${amenity.slug}`}
          className="text-sm text-forest-900 hover:text-brass inline-flex items-center gap-1"
          data-testid={`amenity-more-${amenity.slug}`}
        >
          Learn more →
        </Link>
      </div>
    </article>
  );
}
